/**
 * Email template configurations
 * Matches: Email.Server, Email.EGPlatform
 */
import type { TemplateConfig, TemplateField } from '../types'
import { createExpandedRowRender } from '../../expanded-row'
import { defaultQuotaCalculator, defaultIsExpandable } from '../shared'

// ============================================================================
// Fields
// ============================================================================

export const EMAIL_SERVER_FIELDS: TemplateField[] = [
    {
        key: 'account',
        names: ['account', 'mail-account', 'email-account'],
        label: 'Account',
        headerKey: 'mail-account',
    },
    {
        key: 'storage',
        names: ['storage'],
        label: 'Storage',
        headerKey: 'email-storage',
    },
    {
        key: 'attachment',
        names: ['email-attachment', 'attachment'],
        label: 'Attachment',
        headerKey: 'email-attachment',
    },
    {
        key: 'addon_domain',
        names: ['addon-domain', 'addon_domain'],
        label: 'Addon Domain',
        headerKey: 'addon-domain',
    },
]

export const EMAIL_EGPLATFORM_FIELDS: TemplateField[] = [
    {
        key: 'account',
        names: ['account', 'mail-account', 'email-account'],
        label: 'Account',
        headerKey: 'mail-account',
    },
    {
        key: 'storage',
        names: ['storage'],
        label: 'Storage',
        headerKey: 'email-storage',
    },
]

// ============================================================================
// Template Configs
// ============================================================================

export const emailServerTemplate: TemplateConfig = {
    id: 'email-server',
    patterns: ['email.server'],
    priority: 10,

    fields: EMAIL_SERVER_FIELDS,

    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },

    calculateQuota: defaultQuotaCalculator,
}

export const emailEGPlatformTemplate: TemplateConfig = {
    id: 'email-egplatform',
    patterns: ['email.egplatform'],
    priority: 10,

    fields: EMAIL_EGPLATFORM_FIELDS,

    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },

    calculateQuota: defaultQuotaCalculator,
}

// Export all email templates
export const emailTemplates = [emailServerTemplate, emailEGPlatformTemplate]
